import { getMultiTenancyHeaders } from './multiTenancyHeaders';
import { WISHLIST_SESSION_ITEM_KEY } from '../contexts/ShopifyCustomerProvider';
import { serviceHelper } from '../config/service-helper';

const delay = ms => new Promise(resolve => setTimeout(() => resolve(true), ms));

export async function addOrDeleteWishlist(actionType, sku, variantId) {
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      ...getMultiTenancyHeaders(),
    },
  };

  const data = {
    shopifyCustomerId: window.Jbhifi.shopifyCustomerId ?? window.Jbhifi.customerId,
    Sku: sku,
    VariantId: variantId,
    ActionType: actionType,
  };

  return fetch(serviceHelper.customerWishlistURL, {
    method: 'POST',
    headers: options.headers,
    body: JSON.stringify(data),
    credentials: 'include',
  })
    .then(() => {
      if (actionType === 'removeItem') {
        const wishlistedItemPreLogin = window.sessionStorage.getItem(WISHLIST_SESSION_ITEM_KEY);
        if (wishlistedItemPreLogin && wishlistedItemPreLogin === sku) {
          window.sessionStorage.removeItem(WISHLIST_SESSION_ITEM_KEY);
        }
      }
      return true;
    })
    .catch(() => false);
}

export const waitForWishlist = () =>
  new Promise(async resolve => {
    let wishlistReady = Boolean(window.theme.wishlist);
    let attempts = 0;

    while (!wishlistReady && attempts < 10) {
      await delay(500);
      wishlistReady = Boolean(window.theme.wishlist);
      attempts += 1;
    }

    resolve();
  });
